export const RECIPE_SUPPLIER_TITLE = 'Menu Builder Recipe'
export const RECIPE_TYPE = 'Recipe'

export const getRecipeIdString = recipeOrId => {
  if (!recipeOrId) return ''
  if (typeof recipeOrId === 'string') return recipeOrId
  return String(recipeOrId._id || recipeOrId.id || '')
}

export const buildDefaultRecipeSku = recipe => {
  const keyName = String(recipe?.keyName || '').trim()
  if (keyName) return keyName
  const id = getRecipeIdString(recipe)
  if (!id) return ''
  return `RCP-${id.slice(-6).toUpperCase()}`
}

export const isRecipeStockProduct = product =>
  Boolean(product?.recipeId) || String(product?.type || '') === RECIPE_TYPE

export const getRecipeStockValueMultiplier = product => {
  if (!isRecipeStockProduct(product)) return 1
  if (String(product?.recipePriceMode || 'Portion') === 'Full Recipe') {
    const portions = Number(product?.recipePortionsPerBatch) || 1
    return portions > 0 ? 1 / portions : 1
  }
  return 1
}

export const getEffectiveStockUnitPrice = product => {
  const price = Number(product?.price) || 0
  return price * getRecipeStockValueMultiplier(product)
}

export const getLineStockQuantityValue = (product, quantity) => {
  const qty = Number(quantity) || 0
  return getEffectiveStockUnitPrice(product) * qty
}

export const getRecipePriceForMode = (recipe, priceMode) => {
  const portions = Number(recipe?.portions) || 1
  const costPerPortion = Number(recipe?.costPerPortion) || 0
  const costPerRecipe =
    Number(recipe?.costPerRecipe) > 0
      ? Number(recipe.costPerRecipe)
      : costPerPortion * portions
  return priceMode === 'Full Recipe' ? costPerRecipe : costPerPortion
}
